import React from 'react'

const Header = () => {
  return (
    <div className='header'>
      <h1>Todolist React App</h1>
    </div>
  )
}

export default Header;
